import React from "react"
import { graphql, navigate } from 'gatsby'
import Scrollspy from 'react-scrollspy'
import Img from 'gatsby-image'
import { Link as ScrollLink } from 'react-scroll'
import Layout from "../components/layout"
import SEO from "../components/seo"
// import Sponsor from "../components/sponsor"
// import Newsletter from "../components/newsletter"
import { Link } from '../components/localizedlink'
import AutoAffix from '../utility/affix/AutoAffix'
import Banner from '../components/banner'


const Report2020 = ({ pageContext: { locale }, data }) => (
  <Layout locale={locale}>
    <SEO title="Executive summary IIC 2020" bodyClass="header-testata site-white" />
    <section className="section evento evento--iic hero-testata">
      <Img className="evento__img" loading="eager" fluid={data.hero.childImageSharp.fluid} alt="" />
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <div className="hero-video__content">
              <div className="hero-intro hero-intro--iic">
                <div className="hero-intro__edition">3° Edizione</div>
                <div className="hero-intro__title text-uppercase" itemProp="name">Intranet Italia Champions</div>
                <div className="hero-intro__date">19-20 maggio 2022</div>
                <div className="hero-intro__subject">Il premio per le migliori iniziative intranet italiane</div>
                <div className="hero-intro__claim">
                  Evento ideato da Giacomo Mason di <a href="https://www.intranetmanagement.it/" title="Intranet Management" target="_blank" rel="noopener noreferrer">Intranet Management</a>,  <br className="d-none d-lg-block" />azienda parte di <a href="https://www.ariadnegroup.it/" title="Ariadne Group" target="_blank" rel="noopener noreferrer">Ariadne Group</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div className="bg-fagioloni bg-fagioloni--offset bg-fagioloni--iic">
      <div className="bg-fagioloni__left"></div>
      <div className="bg-fagioloni__right"></div>

      <div className="champions">
        <div className="container">
          <div className="row">
            <div className="d-none d-md-block col-md-5 col-lg-4 col-xl-3 text-center">
              <AutoAffix affixClassName="sidebar sidebar--affix" topClassName="sidebar sidebar--affix-top" bottomClassName="sidebar sidebar--affix-bottom"
                viewportOffsetTop={220} container={() => document.getElementById('scrollContainer')}>
              <div>
                <div className="left-nav--primary left-nav__primary--active">Report 2020</div>
                <nav className="left-nav">
                  <Scrollspy items={['vincitori', 'casestudy', 'tendenze', 'report']} offset={-220}
                    className="left-nav__list" currentClassName="active">
                    <li className="left-nav__item left-nav__item--1">
                      <ScrollLink href="vincitori" to="vincitori" smooth={true} title="i vincitori" className="left-nav__link">Progetti vincenti</ScrollLink>
                    </li>
                    <li className="left-nav__item left-nav__item--2">
                      <ScrollLink href="casestudy" to="casestudy" smooth={true} title="Casi di studio" className="left-nav__link">Casi di studio</ScrollLink>
                    </li>
                    <li className="left-nav__item left-nav__item--3">
                      <ScrollLink href="tendenze" to="tendenze" smooth={true} title="Le 8 tendenze del 2019" className="left-nav__link">Alcune tendenze</ScrollLink>
                    </li>
                    <li className="left-nav__item left-nav__item--4">
                      <ScrollLink href="report" to="report" smooth={true} title="Report 2019" className="left-nav__link">Acquista il report</ScrollLink>
                    </li>
                  </Scrollspy>
                </nav>
                <div className="left-nav--primary"><Link to="/intranet-italia-champions/#champions">Che cos'è IIC</Link></div>
                </div>
              </AutoAffix>
            </div>
            <div className="col-sm-8 col-md-6 col-lg-7 col-xl-7">
              <div className="champions__text" id="scrollContainer">
                <section id="progetti" className="section section--pt">
                  <h1 className="section__title">IIC 2020 Executive Summary: i vincitori, i casi, le tendenze</h1>
                  <p>
                    Anche quest’anno il Premio <Link to="/intranet-italia-champions/#champions">Intranet Italia Champions</Link>, il contest organizzato da Intranet Management e Ariadne Digital, per valorizzare i migliori progetti intranet nella scena italiana, ha regalato sorprese e tante soluzioni di grande interesse ed ispirazione. La giuria, composta da 6 specialisti italiani e stranieri nel campo delle intranet e della comunicazione interna, non ha nascosto le proprie difficoltà nell’assegnare i premi, vista l’alta qualità dei casi presentati che, tutti insieme, costituiscono uno spaccato di innovazione, buone soluzioni, nuovi formati nella comunicazione interna digitale in Italia.
                  </p>
                  <p>
                    Le aziende che sono state selezionate quest’anno per il premio sono:
                  </p>
                  <ul>
                    <li>Aboca</li>
                    <li>Gruppo Acea</li>
                    <li>AGF88 Holding</li>
                    <li>Banca Ifis</li>
                    <li>Erg</li>
                    <li>Huware</li>
                    <li>Poste Italiane (due casi presentati)</li>
                    <li>Reale Mutua Assicurazioni</li>
                    <li>Gruppo Sella</li>
                    <li>Snam</li>
                    <li>Sogei</li>
                    <li>Trenord</li>
                    <li>Trivellato</li>
                  </ul>
                  <p>
                    Di seguito presentiamo i vincitori 2020, i casi e alcune tendenze rilevabili nell’edizione di quest’anno.
                  </p>
                </section>
                <section id="vincitori" className="section"> 
                  <h1 className="section__title">I vincitori</h1>
                  <p>Le cinque aziende vincitrici dell’edizione 2020 dell’IIC sono:</p>
                  <ul>
                    <li><strong>Sogei</strong> - Migliore intranet dell’anno in assoluto</li>
                    <li><strong>Poste Italiane</strong> - Vincitrice della categoria Applicazioni &amp; servizi online</li>
                    <li><strong>Banca Ifis</strong> - Vincitrice della categoria Contenuti</li>
                    <li><strong>Reale Mutua</strong> - Vincitrice della categoria Social</li>
                    <li><strong>Snam</strong> - Vincitrice della categoria Design</li>
                  </ul>
                  <p>Di seguito una breve descrizione dei vincitori.</p>
                  <br/>

                 
                  <h3>Sogei</h3>
                  <p>
                    Mappare gli skill e metterli in gioco nella nuova “Corporate Social Intranet”
                  </p>
                  <Img fluid={data.sogei.childImageSharp.fluid} alt="Sogei" className="champions__img my-4" />
                  <p>
                    <strong>Sogei</strong> ha creato una intranet completa di informazioni pratiche e utility, con una forte partecipazione nel processo di costruzione, l’avvio di community molto ben organizzate e alcune chicche di design quali il profilo personale con gli skill o la dashboard personale. Nel complesso un progetto intranet davvero maturo.
                  </p>

                  <h3 className="mt-5">Poste Italiane</h3>
                  <p>
                     Una APP su misura per i 130.000 dipendenti
                  </p>
                  <Img fluid={data.posteapp.childImageSharp.fluid} alt="Poste Italiane" className="champions__img my-4" />
                  <p>
                    <strong>Poste Italiane</strong> ha creato una App in grado di coinvolgere, informare e comunicare efficacemente. L’app è di fatto il vero touch point del dipendente con l’azienda, con una forte vocazione ai contenuti personalizzati e alla gestione di importanti processi aziendali, capace di connettere in modo semplice ed immediato le persone all’azienda, ovunque si trovino ed in qualunque momento.
                  </p>

                  <h3  className="mt-5">Banca Ifis</h3>
                  <p>
                    Una comunicazione interna rinnovata e coinvolgente e un chatbot integrato
                  </p>
                  <Img fluid={data.ifis.childImageSharp.fluid} alt="Banca Ifis" className="champions__img my-4" />
                  <p>
                    <strong>Banca Ifis</strong> ha creato una serie di contenuti multimediali molto ingaggianti e ha messo a disposizione dei dipendenti un chatbot per le prenotazioni efficace ed innovativo. Completano il quadro una serie interessante e ben costruita di contenuti e servizi (bacheca, video, formazione, survey).
                  </p>

                  <h3 className="mt-5">Reale Mutua</h3> 
                  <p>
                    Really: un Digital Workplace multi-country
                  </p>
                  <Img fluid={data.reale.childImageSharp.fluid} alt="Reale Mutua" className="champions__img my-4" />
                  <p>
                    <strong>Reale Mutua</strong> ha trasformato 7 intranet company in un Digital Workplace multi-country, puntando sul co-design applicato ad ogni fase del progetto. Ha creato un insieme di servizi e contenuti molto ben fatti e soprattutto tante community ben organizzate e molto ben integrate nell’ambiente principale, creando di fatto una vera social intranet, per offrire la stessa user experience a cui le persone sono abituate fuori dall’azienda.
                  </p>

                  <h3 className="mt-5">Snam</h3> 
                  <p>
                     Una intranet multicanale dal design sostenibile
                  </p>
                  <Img fluid={data.snam.childImageSharp.fluid} alt="Reale Mutua" className="champions__img my-4" />
                  <p>
                    <strong>Snam</strong> ha realizzato un redesign efficace e di grande impatto visivo, flessibile e adattabile alle evoluzioni del lavoro ed alle esigenze dei dipendenti, con l’obiettivo di garantire performance elevate in termini di user experience, funzionalità e contenuti. Una intranet ad alto impatto di design, che regala un’esperienza avvolgente ed efficace, costruita attorno alle esigenze del singolo.
                  </p>
            
                </section>

                <section id="casestudy" className="section">
                  <h1 className="section__title">Casi di studio </h1>
                  <p>
                    Di seguito riportiamo i 9 progetti che, nelle diverse categorie del premio, hanno espresso elementi di grande interesse e ispirazione per chiunque si occupi di progetti intranet. Si tratta di realizzazioni interessanti e innovative e, in qualche caso, con soluzioni originali ed efficaci.
                  </p>

                  
                  <h3 className="mt-5">Categoria Applicazioni e servizi online</h3>
                  

                  <p className="mt-4">
                    <strong>Aboca</strong> - Supportare la rete dei farmacisti con formazione, Q&amp;A e gamification
                  </p>
                  <Img fluid={data.aboca.childImageSharp.fluid} alt="Aboca" className="champions__img my-4" />
                  <p>
                    <strong>Aboca</strong> Il Portale è dedicato alle farmacie e ai farmacisti appartenenti al network e ai dipendenti della società Apoteca Natura. È lo strumento dedicato alla gestione delle attività e del rapporto tra la farmacia e il brand.
                  </p>

                  <p className="mt-4">
                    <strong>Huware</strong> - un nuovo onboarding full digital su misura e ben strutturato
                  </p>
                  <Img fluid={data.huware.childImageSharp.fluid} alt="Huware" className="champions__img my-4" />
                  <p>
                    <strong>Huware</strong> ha creato un nuovo news center per aggiornare tutti i dipendenti e ha rivoluzionano il proprio processo di onboarding mettendo al centro il dipendente e consentendo a tutti i settori di collaborare online al percorso di inserimento. Il risultato: efficienza, engaging, presidio migliorato della comunicazione interna, community diffuse.
                  </p>

                  <p className="mt-4">
                    <strong>Trivellato</strong> - Gestire in modo efficiente privacy, ferie e permessi
                  </p>
                  <Img fluid={data.trivellato.childImageSharp.fluid} alt="Trivellato" className="champions__img my-4" />
                  <p>
                    <strong>Trivellato</strong> ha rivisto i propri processi di gestione di ferie, permessi e adempimenti GDPR, semplificando la distribuzione e raccolta dati e automatizzando dove possibile le fasi di richiesta. Con una forte attenzione alla digitalizzazione di tutte le fasi del lavoro e una cura particolare rispetto all’accesso mobile.
                  </p>

                  <h3 className="mt-5">Categoria contenuti</h3>
                

                  <p className="mt-4">
                    <strong>Poste Italiane</strong> - l TG di Poste Italiane: un sistema di comunicazione multicanale a servizio dell’informazione aziendale
                  </p>
                  <Img fluid={data.postetg.childImageSharp.fluid} alt="Poste Italiane" className="champions__img my-4" />
                  <p>
                    <strong>Poste Italiane</strong> ha creato un format di comunicazione molto impegnativo e di elevata qualità, garantendo un flusso di informazioni costante, in tempo reale, su tutti i dispositivi aziendali, per tutta la popolazione interna. Il TG Poste integra tantissime fonti interne per assicurare un prodotto quotidiano sempre disponibile sulla intranet.
                  </p>

                  <p className="mt-4">
                    <strong>Trenord</strong> - INTrenord: una intranet creata intorno alle persone e potenziata dall’AI
                  </p>
                  <Img fluid={data.trenord.childImageSharp.fluid} alt="Trenord" className="champions__img my-4" />
                  <p>
                    <strong>Trenord</strong> Trenord ha creato una serie di format comunicativi di grande impatto, usando i video per valorizzare le persone e i mestieri dell’azienda e per fare conoscere i colleghi di nuovo inserimento, oltre a fornire una serie di servizi utili legati al welfare, ai progetti, ai risultati aziendali, il tutto potenziato dall’IA nella ricerca.
                  </p>

                  <p className="mt-4">
                    <strong>AGF88 Holding</strong> - Una intranet conversazionale per AGF88
                  </p>
                  <Img fluid={data.agf.childImageSharp.fluid} alt="AGF88 Holding" className="champions__img my-4" />
                  <p>
                    <strong>AGF88</strong> ha creato un ambiente conversazionale popolato da contenuti ingaggianti, primi tra tutti la raccolta di mini-interviste ai colleghi, le news, la sezione dedicata al Covid, la bacheca delle idee, l’area dedicata alla pausa pranzo. Una comunicazione interna rinnovata e amplificata.
                  </p>

                  <h3 className="mt-5">Categoria social</h3>
                

                  <p className="mt-4">
                    <strong>Gruppo Sella</strong> - Un programma di podcast per una community ingaggiata.
                  </p>
                  <Img fluid={data.sella.childImageSharp.fluid} alt="Gruppo Sella" className="champions__img my-4" />
                  <p>
                    <strong>Gruppo Sella</strong> ha creato un format ingaggiante di comunicazione periodica per valorizzare i progetti interni e le persone dell’azienda, e ha utilizzato queste occasioni come altrettanti spunti per alimentare le community interne, con il risultato di aumentare sia l’informazione a disposizione sia la partecipazione diffusa.
                  </p>

                  <h3 className="mt-4">Categoria design</h3>
              

                  <p className="mt-4">
                    <strong>Gruppo Acea</strong> - Un redesign all’insegna della semplificazione, personalizzazione e condivisione.
                  </p>
                  <Img fluid={data.acea.childImageSharp.fluid} alt="Gruppo Acea" className="champions__img my-4" />
                  <p>
                    <strong>Acea</strong> ha realizzato un redesign della vecchia intranet capace di mettere al centro la semplicità, l’identità aziendale e la visibilità dei progetti delle aree industriali del Gruppo. La intranet presenta oggi un layout uniforme e caratterizzato, una serie di servizi utili rinnovati nell’interaction design e un ambiente fortemente personalizzabile dai singoli dipendenti.
                  </p>

                  <p className="mt-4">
                    <strong>Erg</strong> - Un design completamente rinnovato, contenuti multimediali e nuove funzionalità
                  </p>
                  <Img fluid={data.erg.childImageSharp.fluid} alt="Erg" className="champions__img my-4" />
                  <p>
                    <strong>Erg</strong> ha saputo creare un design fresco e coerente con l’immagine aziendale, con una soluzione capace di coniugare esigenze operative e di comunicazione. Tra contenuti globali, sezioni locali, uso del chatbot e breaking news, il redesign presenta oggi un ambiente informativo efficace, aggiornato e fortemente caratterizzato.
                  </p>
                 
                </section>

                <section id="tendenze" className="section">
                  <h1 className="section__title">Alcune tendenze</h1>
                  <p>
                    Anche quest’anno, come per l’anno passato, possiamo identificare alcune tendenze all’interno dei casi in concorso, che corrispondono ad altrettanti trend osservati anche in ambito internazionale. <br/>
                    Ne abbiamo identificate dieci:
                  </p>
                  <ol>
                    <li>Uso dei chatbot</li>
                    <li>Formati podcast</li>
                    <li>Profili arricchiti</li>
                    <li>Filtri multipli</li>
                    <li>Sezioni "Come fare per…"</li>
                    <li>Sezioni "Covid" e "Smart working"</li>
                    <li>Dipendenti protagonisti</li>
                    <li>Personalizzazioni dell’interfaccia</li>
                    <li>Ricerca intelligente</li>
                    <li>Metodi User Centered</li>
                  </ol>

                  <p className="mt-4">
                    <strong>1 - Benvenuto chatbot</strong><br/>
                    Finalmente, anche nelle intranet italiane cominciano ad emergere buoni esempi di chabot e assistenti virtuali. I chatbot possono essere usati, come in <strong>Erg</strong>, per aiutare nella ricerca di informazioni oppure, come nel caso di <strong>Banca Ifis</strong>, sono dei veri assistenti virtuali che possono svolgere task precisi, guidando l’utente in modo conversazionale, ad esempio nella prenotazione di viaggi o di appuntamenti.
                  </p>
                  <p>
                    <figure className="champions__img">
                      <Img fluid={data.chatbot.childImageSharp.fluid} alt="Erg" className="champions__img my-4" />
                      <figcaption>
                        <strong>Chatobt assistant</strong> In Banca Ifis un chatbot provvede ad assistere conversazionalmente gli utenti nella prenotazione di molti servizi, dagli hotel ai treni (in questo caso, del test sierologico per il Covid 19).
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>2 - Il podcast che ci piace</strong><br/>
                    Il podcast esce dalla nicchia meramente “radiofonica” nel quale oggi trova la sua collocazione prevalente, per diventare un formato di comunicazione interna a tutti gli effetti. Oltre ai podcast di <strong>Banca Ifis</strong>, segnaliamo quest’anno anche la serie di podcast inaugurati dal <strong>Gruppo Sella</strong>, sia di tipo professionale che, a grande richiesta, anche legati a passioni e attività extra-lavorative dei dipendenti. Il podcast si conferma un formato flessibile, adattabile ai diversi contesti quotidiani, fruibile anche in mobilità e associabile in contemporanea ad altre attività della persona.
                  </p>
                  <p>
                    <figure className="champions__img">
                      <Img fluid={data.podcast.childImageSharp.fluid} alt="Il podcast che ci piace" className="champions__img my-4" />
                      <figcaption>
                        <strong>Podcast e community. </strong>Il Gruppo Sella ha avviato una serie di interviste podcast ai dipendenti, che hanno portato a una serie di discussioni nella community interna.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>3 - Il profilo agli steroidi</strong><br/>
                    I profili personali, generalmente associati alla rubrica/cercapersone, stanno attraversando una fase di ulteriore arricchimento, e diventando degli hub dove le persone ritrovano attività, competenze, tag. È il caso ad esempio di <strong>Reale Mutua</strong>, con un profilo personale che riporta lo storico delle attività sulla intranet, o di <strong>Sogei</strong>, con il profilo personale che contiene anche una sezione dedicata agli skill posseduti, visibile a tutti i dipendenti con anche la possibilità di “endorsement” ai colleghi, o ancora di <strong>Snam</strong>, in cui il profilo personale contiene anche i tag riferiti alle mansioni e microattività di ciascuno (puoi rivolgerti a me per..)
                  </p>
                  <p>
                    <figure className="champions__img">
                      <Img fluid={data.profilo.childImageSharp.fluid} alt="Il profilo agli steroidi" className="champions__img my-4" />
                      <figcaption>
                        <strong>Profilo e skill. </strong>Il profilo personale nella intranet di Sogei contiene anche una sezione dedicata agli skill posseduti, visibile a tutti i dipendenti, con anche la possibilità di “endorsement” ai colleghi.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>4 - Il filtro che ti salva</strong><br/>
                    Sempre più intranet affidano la possibilità di individuare le risorse (news, notifiche, documenti, persone, ecc.) a sistemi di filtri multipli mediati dai sistemi di E-commerce. È il caso ad esempio di <strong>Erg</strong>, con filtri applicati alla rubrica o alle policy, di <strong>Trenord</strong>, con filtri applicati alla ricerca, o di <strong>Acea</strong>, con filtri applicati alle procedure. In questo modo è possibile gestire una grande massa di contenuti in modo organico.                  
                  </p>
                  <p>
                    <figure className="champions__img">
                      <Img fluid={data.filtri.childImageSharp.fluid} alt="Il filtro che ti salva" className="champions__img my-4" />
                      <figcaption>
                        <strong>Filtri multipli. </strong>Il sistema di filtri multipli applicato all’area procedure di Acea.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>5 - La centralità del “Come fare per”</strong><br/>
                    Le aree dedicate al “Come fare per” conquistano sempre più spazio e visibilità, finendo talvolta al primo livello nella navigazione. Sono soluzioni adottate ad esempio da <strong>Sogei</strong> (“Cosa fare per”) o da <strong>Snam</strong>, con un sistema completo e scalabile, suddiviso in categorie.                  
                  </p>
                  <p>
                    <figure className="champions__img">
                      <Img fluid={data.comefare.childImageSharp.fluid} alt="Come fare per" className="champions__img my-4" />
                      <figcaption>
                        <strong>Come fare per. </strong>Nella intranet di Snam il “Come fare per” presenta una serie di card suddivise per categorie. Il sistema è al primo livello di navigazione sotto la home page
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>6 - Covid e Smart working</strong><br/>
                    Come era prevedibile, quasi tutte le intranet si sono dotate di sezioni dedicate alle informazioni per gestire il periodo pandemico, in special modo per quanto riguarda la sicurezza sul lavoro e lo smart working. È il caso ad esempio di <strong>Sogei</strong>, di <strong>Banca Ifis</strong>, o di <strong>Agf88 holding</strong>                  
                  </p>
                  <p> 
                    <figure className="champions__img">
                      <Img fluid={data.covid.childImageSharp.fluid} alt="Covid e Smart working" className="champions__img my-4" />
                      <figcaption>
                        <strong>Sezione Covid. </strong>La sezione dedicata al Covid 19 della intranet di AGF88 Holding
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>7 - Dipendenti protagonisti</strong><br/>
                    I dipendenti sono sempre più protagonisti dei palinsesti editoriali delle intranet: sono molte le iniziative che li mettono al centro, con interviste periodiche (ad esempio la sezione “Conosciamoci” di <strong>AGF88 Holding</strong>) o con video rubriche dedicate al loro mestiere, come nel caso di “Il bello di Trenord”, rubrica video presente sulla intranet di <strong>Trenord</strong>.                 
                  </p>
                  <p> 
                    <figure className="champions__img">
                      <Img fluid={data.videorubriche.childImageSharp.fluid} alt="Dipendenti protagonisti" className="champions__img my-4" />
                      <figcaption>
                        <strong>Video rubriche. </strong>La rubrica “Il bello di Trenord” presenta una raccolta di video interviste sui diversi mestieri delle persone dell’azienda.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>8 - Personalizzami!</strong><br/>
                    Le possibilità di personalizzare parte dell’interfaccia della intranet sono ormai parte stabile delle possibilità offerte dal design di questi strumenti. Un classico in questo senso sono i preferiti, selezionabili tra un set predefinito. Nel caso ad esempio di <strong>Erg</strong>, i singoli dipendenti possono personalizzare una serie di link rapidi che saranno sempre a portata di mano sulla destra. Stessa cosa in <strong>Snam</strong>, con una parte della sidebar personale dedicata alle risorse salvate dai singoli dipendenti.
                  </p>
                  <p> 
                    <figure className="champions__img">
                      <Img fluid={data.preferiti.childImageSharp.fluid} alt="Personalizzami" className="champions__img my-4" />
                      <figcaption>
                        <strong>Preferiti. </strong>Nella intranet di Erg i dipendenti hanno salvato una serie di tool che possono ritrovare costantemente a partire dalla home paga.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>9 - Ricerca intelligente</strong><br/>
                    Anche la ricerca è sempre più evoluta: dalla possibilità di interpretare il linguaggio naturale (<strong>Trenord</strong>) alla ricerca con autocomplete intelligente (<strong>Acea</strong>) fino alla ricerca integrata in <strong>Snam</strong>, che presenta, fin da subito, man mano che si digita un termine, una serie di risorse pertinenti raggruppate per tipo (news, media, persone, documenti ecc...)                 
                  </p>
                  <p> 
                    <figure className="champions__img">
                      <Img fluid={data.ricerca.childImageSharp.fluid} alt="Ricerca intelligente" className="champions__img my-4" />
                      <figcaption>
                        <strong>Ricerca integrata. </strong>Nella intranet di Snam, al digitare di un termine appaiono, raggruppate per tipo, tutte le risorse correlate.
                      </figcaption>
                    </figure>
                  </p>

                  <p className="mt-4">
                    <strong>10 - User centered intranet</strong><br/>
                    Finalmente si stanno affermando, in moltissimi progetti, tecniche e strumenti di user centered design: Workshop, interviste, personas, diari, tree test e molti altri strumenti per coinvolgere le persone dell’azienda in tutte le fasi del processo. Tra i tanti esempi arrivati, in <strong>Acea</strong> sono state realizzate diverse sessioni di design thinking con i dipendenti per esplorare i futuri contenuti della intranet e in <strong>Sogei</strong> sono stati coinvolti più di 300 colleghi nelle fase di ricerca, e sono state poi realizzate diverse personas, per orientare il progetto nella direzione dei diversi target riconosciuti.                 
                  </p>
                  <p> 
                    <figure className="champions__img">
                      <Img fluid={data.personas.childImageSharp.fluid} alt="User centered intranet" className="champions__img my-4" />
                      <figcaption>
                        <strong>Personas. </strong>. In Sogei sono state realizzate diverse personas, a valle della fase di ricerca, per orientare il progetto nella direzione dei diversi target riconosciuti.
                      </figcaption>
                    </figure>
                  </p>

                </section>

                <section id="report" className="section">
                  <h1 className="section__title">Per approfondire:<br /> scarica il report IIC2020</h1>
                  <p>
                    I dettagli di tutti i casi, completi di screenshot e didascalie, sono contenuti nel <Link title="Report IIC 2019" to="/acquista-report-iic-2020/"> report IIC2020</Link><br />
                  </p>
                  

                  <div className="champions__internalCTA text-center">
                    <button onClick={e => navigate('/acquista-report-iic-2020/')} className="btn-cta btn-style-2">
                      Acquista il report
                    </button>
                  </div>
                </section>
                <Banner iic={true}/>
                {/* <Sponsor iic={true} /> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* <Newsletter /> */}
    </div>
  </Layout >
);

export default Report2020;

export const query = graphql`
  fragment sharpReport on File {
    childImageSharp{
      fluid (maxWidth: 800, quality: 100 ){
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
  query ReportIIC2020Query{
    hero: file(relativePath: { eq: "hero-iic.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    aboca: file(relativePath: {eq: "contents/iic2020/ABOCA.png"}){
      ...sharpReport
    }
    acea: file(relativePath: {eq: "contents/iic2020/ACEA.jpg"}){
      ...sharpReport
    }
    agf: file(relativePath: {eq: "contents/iic2020/AGF_88.png"}){
      ...sharpReport
    }
    ifis: file(relativePath: {eq: "contents/iic2020/BANCA_IFIS.jpg"}){
      ...sharpReport
    }
    erg: file(relativePath: {eq: "contents/iic2020/ERG.png"}){
      ...sharpReport
    }
    sella: file(relativePath: {eq: "contents/iic2020/GRUPPO_SELLA.jpg"}){
      ...sharpReport
    }
    huware: file(relativePath: {eq: "contents/iic2020/HUWARE.png"}){
      ...sharpReport
    }
    posteapp: file(relativePath: {eq: "contents/iic2020/POSTE_APP.png"}){
      ...sharpReport
    }
    postetg: file(relativePath: {eq: "contents/iic2020/POSTE_TG.png"}){
      ...sharpReport
    }
    reale: file(relativePath: {eq: "contents/iic2020/REALE_MUTUA.png"}){
      ...sharpReport
    }
    snam: file(relativePath: {eq: "contents/iic2020/SNAM.png"}){
      ...sharpReport
    }
    sogei: file(relativePath: {eq: "contents/iic2020/SOGEI.jpg"}){
      ...sharpReport
    }
    trenord: file(relativePath: {eq: "contents/iic2020/TRENORD.png"}){
      ...sharpReport
    }
    trivellato: file(relativePath: {eq: "contents/iic2020/TRIVELLATO.png"}){
      ...sharpReport
    }
    chatbot: file(relativePath: {eq: "contents/iic2020/1-chatbot.png"}){
      ...sharpReport
    }
    podcast: file(relativePath: {eq: "contents/iic2020/2-podcast.jpg"}){
      ...sharpReport
    }
    profilo: file(relativePath: {eq: "contents/iic2020/3-profilo.jpg"}){
      ...sharpReport
    }
    filtri: file(relativePath: {eq: "contents/iic2020/4-filtri.png"}){
      ...sharpReport
    }
    comefare: file(relativePath: {eq: "contents/iic2020/5-come-fare-per.png"}){
      ...sharpReport
    }
    covid: file(relativePath: {eq: "contents/iic2020/6-covid.png"}){
      ...sharpReport
    }
    videorubriche: file(relativePath: {eq: "contents/iic2020/7-videorubriche.png"}){
      ...sharpReport
    }
    preferiti: file(relativePath: {eq: "contents/iic2020/8-preferiti.png"}){
      ...sharpReport
    }
    ricerca: file(relativePath: {eq: "contents/iic2020/9-ricerca.png"}){
      ...sharpReport
    }
    personas: file(relativePath: {eq: "contents/iic2020/10-personas.png"}){
      ...sharpReport
    }
  }
`;

